import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  maplink: {
    id: 'map_card.directionslink',
    description:
      "Label for a link that links to map showing the location of the provider's office",
    defaultMessage: 'Get Directions'
  },
  mapSnackbarMessage: {
    id: 'mapSnackbar.message',
    description: "Text for the map's introductory snackbar",
    defaultMessage: 'Click on the pins to view locations and providers'
  },
  mapSnackbarButton: {
    id: 'mapSnackbar.button',
    description: "Text for the map's introductory snackbar's close button",
    defaultMessage: 'Got It'
  },
  backToListView: {
    id: 'map_card.backToListView',
    description: 'Map view button text to go back list view',
    defaultMessage: 'List View'
  },
  filterBtn: {
    id: 'map_card.filter',
    description: 'Map view button text filter',
    defaultMessage: 'Filter'
  },
  close: {
    id: 'resultsheader.close',
    description: 'Button text to close filter results',
    defaultMessage: 'Close'
  },
  viewProvidersAtLocation: {
    id: 'buttons.view_providers_at_location',
    description:
      'Text for the mobile map card CTA that triggers the provider drawer for map-search',
    defaultMessage: 'View Providers at this Location'
  },
  bookAppointmentOnline: {
    id: 'buttons.book_appointment_online',
    description:
      'Text for the mobile map card CTA that routes to /book for bookable locations',
    defaultMessage: 'Book Appointment Online'
  },
  bannerCloseMsg: {
    id: 'map_card.noSortAndFilterOptions_closeMsg',
    description: 'no sort/filter banner close link ',
    defaultMessage: 'close this message'
  },
  noFilterOptions: {
    id: 'map_card.noFilterOptions',
    description: '',
    defaultMessage: 'There are no filter options available.'
  },
  noResultsMapsProviderErrorTitle: {
    id: 'map_card.noResultsMapsProviderErrorTitle',
    description: 'provider drawer banner title when no results',
    defaultMessage: 'No Results'
  },
  noResultMapsProviderBannerMsg: {
    id: 'map_card.noResultMapsProvider',
    description: 'provider drawer banner content when no results',
    defaultMessage:
      'There are no results for this location. Please select a different location on the map, {backToSearchResult} or {startNewSearch}'
  },
  noMlocDataMapsProviderBannerMsg: {
    id: 'map_card.noMlocDataMapsProvider',
    description: 'provider banner content when no mloc results',
    defaultMessage: `The locations of your results can't be displayed on the map. To see results based on this criteria {backToSearchResult}`
  },
  noResultMapsProviderBannerNewSearchLink: {
    id: 'map_card.noResultMapsProviderNewSearchLink',
    description: 'provider drawer banner start new search link',
    defaultMessage: 'Start a new search'
  },
  loadingErrorMapsProviderErrorTitle: {
    id: 'map_card.loadingErrorMapsProviderErrorTitle',
    description: 'provider drawer loading error banner title',
    defaultMessage: 'Error Loading Results'
  },
  loadingErrorMapsProviderBannerMsg: {
    id: 'map_card.loadingErrorMapsProvider',
    description: 'provider drawer loading error banner content',
    defaultMessage:
      'We had trouble loading your search. {pleaseTryAgain} or {startNewSearch}'
  },
  loadingErrorMapsProviderBannerTryAgainLink: {
    id: 'map_card.loadingErrorMapsProviderPleaseTryAgainLink',
    description: 'provider drawer loading error reload page link',
    defaultMessage: 'Please try again'
  },
  noResultMapsGoBackToListPageLink: {
    id: 'map_card.noResultMapsGoBackToListPageLink',
    description: 'back link to go back previous search results',
    defaultMessage: 'Go back to the search results page'
  },
  backToMapView: {
    id: 'map_card.backToMapView',
    description:
      'Street view button text to close street view and return to map view',
    defaultMessage: 'Back to Map View'
  },
  backToList: {
    id: 'map_card.backToList',
    description: 'Map view button text to go back list view',
    defaultMessage: 'List'
  },
  filtersBtn: {
    id: 'map_card.filters',
    description: 'Map view button text filters',
    defaultMessage: 'Filters'
  }
});
